import IconTextGroupList from './IconTextGroupList';
import { IconTextGroupListProps, IconTextGroupListValueProps } from './types';

export type { IconTextGroupListProps, IconTextGroupListValueProps };
export default IconTextGroupList;
